import React from 'react';
import {
  AverageResultsDivider,
  DarkSkinHero,
  LHRForDarkerTones,
  UnlimitedPackageBenefits,
  LHRSafeForDark,
  SEO,
} from '../../components';
import { graphql } from 'gatsby';

function DarkSkinPage() {
  return (
    <main id='darkskin-page'>
      <DarkSkinHero />
      <AverageResultsDivider />
      <LHRSafeForDark />
      <LHRForDarkerTones />
      <UnlimitedPackageBenefits />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Laser Hair Removal for Dark Skin Tones | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Say goodbye to unwanted hair with our laser hair removal for dark skin. Book now and experience the confidence of flawless, smooth skin.'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default DarkSkinPage;
